import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Description } from '@material-ui/icons';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  subtitle?: string;
}

const DEFAULT_ICON_STYLE: React.CSSProperties = {
  fontSize: 64,
  color: '#bdbdbd',
  marginBottom: 16,
};

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title = 'Выберите контрагента или помещение',
  subtitle = 'Используйте фильтры для поиска контрагентов или помещений',
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
    >
      {icon || <Description style={DEFAULT_ICON_STYLE} />}
      <Typography variant="h6" color="textSecondary" gutterBottom>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" style={{ color: '#9e9e9e' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default EmptyState;
